import { Wrapper } from '../_app.style'
import { styled } from '../stitches.config'
import { TIMELINE_COL_WIDTH, TIMELINE_COL_WIDTH_HALVED } from './constants.style'
import {TIMELINE_TRACK_HEIGHT, NAVIGATION_HEIGHT} from '../../constants/global'


export const MainBackgroundArea = styled('div', {
  gridArea: 'background',
  position: 'relative',
  display: 'grid',
  gridTemplateRows: 'auto',
  rowGap: 0,
  zIndex: 5,
  background: 'white',
  borderBottomRightRadius: 16,
  borderBottomLeftRadius: 16,
})

export const TopBarArea = styled('div', {
  gridArea: 'topbar',
  position: 'sticky',
  top: 0, 
  zIndex: 8, 
  paddingTop: '1rem',
  minWidth: 0,        // Allows the grid item to shrink below content size
  width: '100%',      // Ensures it tries to fill the available grid space
  overflow: 'hidden', // Cuts off anything sticking out
  '& > *': { margin: 0 },

  '@media (max-width: 900px)': {
    paddingLeft: '5.8rem',
  },

})

export const ModulesArea = styled(Wrapper, {
  /* ① declare a private variable with a default */
  $$modulesWidth: TIMELINE_COL_WIDTH,

  gridArea: 'modules',
  display: 'grid',
  gap: '0.5rem',
  gridTemplateRows: `repeat(24, ${TIMELINE_TRACK_HEIGHT})`,
  rowGap: 0,
  position: 'sticky',
  left: 0,
  zIndex: 3,
  // top: '2rem',           // assumes the nav bar is not overlapping
  backgroundColor: '$blueBackground',
  // borderRight: '1px solid $elementBorder',
  borderTopRightRadius: 16,
  paddingBottom: '0.05rem',
  borderRight: '1px solid $elementBorder',


  '@media (max-width: 900px)': {
    $$modulesWidth: '3.2rem',
    width: '$$modulesWidth',

    

  },



  /* ② use the variable for the actual column width */
  width: '$$modulesWidth',
  // paddingTop: '2rem',      // 1. Creates a 1rem "buffer" at the top
  // overflow: 'hidden',  

  /* ③ configure variants */
  variants: {
    size: {
      lg: { 
        $$modulesWidth: TIMELINE_COL_WIDTH,
        '@media (max-width: 900px)': {
          $$modulesWidth: '3.2rem',
        },

      },
      sm: { $$modulesWidth: TIMELINE_COL_WIDTH_HALVED,
            borderTop: '1px solid $elementBorder',
       },
    },
  },
  defaultVariants: { size: 'lg' },

  '&::after': {
    // Required to make the pseudo-element render
    content: "''",
    // Position it relative to the ModulesArea
    position: 'absolute',
    // Place its top edge exactly at the bottom of the main element
    top: '100%',
    left: 0,

    // The extra height you wanted
    height: '1rem',

    // Use the same CSS variable so its width always matches the parent
    width: '$$modulesWidth',

    // '@media (max-width: 900px)': {
    //   width: ''
    // },

    // Match the background for a seamless look
    backgroundColor: '$blueBackground',

    // This adds the curved corner at the bottom-right
    // borderBottomRightRadius: 16,
    bottom: '-1rem',
    borderBottom: '1px solid $elementBorder',
    borderRight: '1px solid $elementBorder',

  },

})


export const EventsArea = styled('section', {
  gridArea: 'bg',      // same area as MainBackground buttons
  position: 'relative',
  pointerEvents: 'none', // let clicks fall through unless re-enabled
});


export const SwitcherArea = styled(Wrapper, {
  $$switcherWidth: TIMELINE_COL_WIDTH,

  gridArea: 'switcher',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  alignItems: 'center',
  paddingTop: '1rem',
  background: '$blueBackground',
  position: 'sticky',
  left: 0,
  // top: '1rem',
  top: 0,
  width: '$$switcherWidth',
  zIndex: 100000,
  borderBottomRightRadius: 16,
  // borderTopRightRadius: 16,
  // border: '1px solid $elementBorder',
  borderRight: '1px solid $elementBorder',
  borderBottom: '1px solid $elementBorder',
  // paddingBottom: '0.1rem',

  '@media (max-width: 900px)': {
    paddingTop: '0.1rem',
    paddingBottom: '0.1rem',
  },



  variants: {
    size: {
      lg: { $$switcherWidth: TIMELINE_COL_WIDTH },
      sm: { $$switcherWidth: TIMELINE_COL_WIDTH_HALVED },
    },
  },
  defaultVariants: { size: 'lg' },



})


export const SwitcherMonthLabel = styled('div', {
  fontWeight: 600, 
  lineHeight: 2,
  fontSize: '1.2rem',
  padding: '0.25rem 0 0.25rem',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  width: '100%',
  // color: '$blue11'
  '@media (max-width: 900px)': {
    display: 'none', // 👈 This is all you need.
  },
})

export const WeeksArea = styled(Wrapper, {
  gridArea: 'weeks',
  position: 'sticky',
  // top: '5.5rem',
  // top: '3.5rem',

  // gapTop: '1rem',

  // top: '0rem',
  padding: '1rem 1rem 0.5rem',
  zIndex: 7,
  overlfow: 'hidden',
  backgroundColor: '$blueWeeks',
  borderTopLeftRadius: 16,
  borderTopRightRadius: 16,

  // top: 'var(--header-height, 4.2rem)',

  variants: {
    small: {
      true: {
        top: '5rem',
        // top: '2rem',
        // top: 'calc(var(--header-height, 4.2rem) + 1rem)',

      },
      false: {
        top: '4.2rem',
        // top: '5rem',
      }
      
    }

  },
  defaultVariants: {
    small: 'false',
  }

})


export const ExperimentArea = styled('div', {
  // gridArea: 'popup',
  display: 'none',

  '&.popup-open': {
    '@media (max-width: 900px)': {
      gridArea: 'popup',
      bottom: 0,
      left: 0,
      right: 0, 
      height: `calc(45dvh / var(--scale, 1))`,
      // height: '45dvh',
      display: 'block',
      // padding: '1rem 1rem 0.5rem',
      zIndex: 100,
      paddingLeft: '1rem',
      paddingBottom: '1rem',
      paddingRight: '1rem',
      overflow: 'hidden',
      position: 'fixed', 
      // bottom: 0,
      // height: '50rem',
      backgroundColor: '#f0f2f5', // Match page color (black for testing is fine)
      // borderTopLeftRadius: 16,
      // borderTopRightRadius: 16,
    },
    '&.keyboard-open': {
       top: 0, // 👈 Release it from the bottom!
       position: 'static',

       
       // Now it will listen to the Grid:
       gridArea: 'popup', 
       
       // Make it fill the space defined by the grid (1fr)
       height: '100%',     
       width: '100%',
       
       // Reset corners if you want it to look like a full page
      //  borderRadius: 0, 
      //  borderTop: '1px solid $elementBorder', // Optional separator
    }
  }
 

});

export const BottomGapStrip = styled('div', {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0, // Stretch full width
  
  height: '2rem', 
  '@media (max-width: 900px)': {
    '&.popup-open': {
        bottom: `calc(45dvh / var(--scale, 1))`,
      },
  },
  background: '#f0f2f5', // Match page color (black for testing is fine)
  pointerEvents: 'none',
  zIndex: 100, // Ensure it sits on top of the scrolling modules
});









export const GapCover = styled('div', {
  position: 'fixed',
  top: NAVIGATION_HEIGHT,    // right below your header
  left: 0,
  right: 0,
  height: '10.5rem',
  backgroundColor: '#f0f2f5',// your non-clickable light grey
  zIndex: 4,                 // < WeeksArea (4) but > main timeline (<3)
  pointerEvents: 'auto', 

})

export const TopBarSpacer = styled('div', {
  gridArea: 'gap',
  height: '1rem',
});


export const HeaderBackdrop = styled('div', {
  // This tells the element to start at row line 1, column line 1,
  // and span all the way to row line 3, and the last column line.
  // This covers both the switcher and weeks areas perfectly.
  // gridArea: '1 / 1 / 3 / -1',
  // gridColumn: '2 / -1', 
  // // Place it in the 2nd row, where the WeeksArea lives.
  // gridRow: '2 / 3', 
  position: 'sticky',
  top: 0,
  gridArea: 'topbar',
  height: '4rem',
  // borderTopRightRadius: '16px', 
  
  // The background color you want
  // backgroundColor: '#f0f2f5', // The subtle grey
  backgroundColor: '#f0f2f5',
  
  // Make sure it sits behind the header text but on top of the main background
  zIndex: 7, 



});


export const HeaderGapBackdrop = styled('div', {
  // This tells the element to start at row line 1, column line 1,
  // and span all the way to row line 3, and the last column line.
  // This covers both the switcher and weeks areas perfectly.
  // gridArea: '1 / 1 / 3 / -1',
  // gridColumn: '2 / -1', 
  // // Place it in the 2nd row, where the WeeksArea lives.
  // gridRow: '2 / 3', 
  position: 'sticky',
  top: 'var(--topbar-h, 4rem)',            // sit just under the top bar

  gridArea: 'gap',
  height: '1rem',

  backgroundColor: '#f0f2f5',
  
  // Make sure it sits behind the header text but on top of the main background
  zIndex: 7, 

  '&::after': {
    // This content property is required for a pseudo-element to appear
    content: '""',
    // position: 'sticky',
    position: 'absolute',
    // Makes the element a block that can have a height/width
    display: 'block',
    
    // The color you wanted
    backgroundColor: '#f0f2f5',
    
    // Your request for "an inch"
    height: '2rem', 
    
    // Makes the bar span the full width of the parent
    width: '100%',
  },

});

// A light-grey mask that sits above the Modules (hour labels) column,
// so the column scrolls “under” the card’s grey header band.
export const ModulesBackdrop = styled('div', {
  gridArea: 'switcher',
  position: 'sticky',
  top: 0,
  height: '0rem', // same thickness as the header gap
  backgroundColor: 'red',
  zIndex: 7,
  pointerEvents: 'none',
  // nice rounding to match your card
  borderTopLeftRadius: 16,

  '&::after': {
    // This content property is required for a pseudo-element to appear
    content: '""',
    // position: 'sticky',
    position: 'absolute',
    // Makes the element a block that can have a height/width
    display: 'block',
    
    // The color you wanted
    backgroundColor: '#f0f2f5',
    
    // Your request for "an inch"
    height: '8.2rem', 
    
    // Makes the bar span the full width of the parent
    width: '100%',
  },
});


export const SwitcherBackdrop = styled('div', {
  // This tells the element to start at row line 1, column line 1,
  // and span all the way to row line 3, and the last column line.
  // This covers both the switcher and weeks areas perfectly.
  // gridArea: '1 / 1 / 3 / -1',
  // gridColumn: '2 / -1', 
  // // Place it in the 2nd row, where the WeeksArea lives.
  // gridRow: '2 / 3', 
  position: 'sticky',
  top: 0,
  gridArea: 'switcher',
  
  // The background color you want
  backgroundColor: '#f0f2f5', // The subtle grey
  
  // Make sure it sits behind the header text but on top of the main background
  zIndex: 7, 
  bottom: '10rem',
 '&::after': {
    // This content property is required for a pseudo-element to appear
    content: '""',
    // position: 'sticky',
    position: 'absolute',
    // Makes the element a block that can have a height/width
    display: 'block',
    
    // The color you wanted
    backgroundColor: '#f0f2f5',
    
    // Your request for "an inch"
    height: '4.5rem', 
    
    // Makes the bar span the full width of the parent
    width: '100%',
  },
});

export const GapCoverSignUp = styled('div', {
  gridArea: 'weeks',
  // position: 'fixed',
  // top: 0,    // right below your header
  // left: 0,
  // right: 0,
  // height: '7rem',            // match the WeeksArea’s top padding/gap
  backgroundColor: 'red',// your non-clickable light grey
  zIndex: 1000,                 // < WeeksArea (4) but > main timeline (<3)
  pointerEvents: 'auto', 
  position: 'sticky',
  top: 0

}) 



export const GapCoverSignUptest = styled('div', {
  gridArea: 'background',
  // position: 'fixed',
  // top: 0,    // right below your header
  // left: 0,
  // right: 0,
  // height: '7rem',            // match the WeeksArea’s top padding/gap
  backgroundColor: 'red',// your non-clickable light grey
  zIndex: 1000,                 // < WeeksArea (4) but > main timeline (<3)
  pointerEvents: 'auto', 
  position: 'sticky',
  top: 0

}) 

// A static patch that sits at the bottom-left of the VIEWPORT, not the content
export const BottomCornerMask = styled('div', {
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: 'TIMELINE_COL_WIDTH', // Match your column width
  height: '1rem',
  
  // High Z-Index to sit ON TOP of the scrolling content
  zIndex: 20, 
  pointerEvents: 'none', // Let clicks pass through if needed

  // The Magic: This matches your background color (#f0f2f5)
  // It effectively "hides" the square corner of the scrolling content
  background: '#f0f2f5', 
  
  // Create the INVERSE radius (the scoop)
  // There are fancy CSS tricks for this using radial-gradient, 
  // or you can use your border-radius trick inverted.
  borderTopRightRadius: 16, 
});


export const GapCoverSignUp2 = styled('div', {
  gridArea: 'switcher',
  // position: 'fixed',
  // top: 0,    // right below your header
  // left: 0,
  // right: 0,
  // height: '7rem',            // match the WeeksArea’s top padding/gap
  backgroundColor: 'red',// your non-clickable light grey
  zIndex: 1000,                 // < WeeksArea (4) but > main timeline (<3)
  pointerEvents: 'auto', 
  position: 'sticky',
  top: 0

}) 

export const GapCover2 = styled('div', {
  position: 'fixed',
  left: 0,
  right: 0,
  height: '8rem',            // match the WeeksArea’s top padding/gap
  backgroundColor: '#f0f2f5',// your non-clickable light grey
  zIndex: 6,                 // < WeeksArea (4) but > main timeline (<3)
  pointerEvents: 'auto', 
})

export const CornerPatch = styled('div', {
  // Position it to live in the gap between the switcher and main area
  position: 'sticky',

  // Use the same CSS variable as SwitcherArea to get its width
  $$cornerPatchOffset: TIMELINE_COL_WIDTH,
  left: '$$cornerPatchOffset',

  // Match the sticky top value of WeeksArea
  top: '1rem',

  // The patch should be the exact size of the corner you need to create
  width: '1rem',    // aThe width of your column-gap
  height: '1rem',   // The height of the space above WeeksArea (its top padding)

  // The visual fix
  backgroundColor: 'black', // Match the WeeksArea background
  borderTopLeftRadius: 16,       // Match the WeeksArea radius

  // Ensure it sits above the grey background but below other content
  zIndex: 20,
  pointerEvents: 'none', // Clicks should pass through it

  // Add variants to ensure the patch moves when the sidebar size changes
  variants: {
    size: {
      lg: { $$cornerPatchOffset: TIMELINE_COL_WIDTH },
      sm: { $$cornerPatchOffset: TIMELINE_COL_WIDTH_HALVED },
    },
  },
  defaultVariants: { size: 'lg' },
});


export const WeeksBackdropStrip = styled('div', {
  position: 'sticky',
  top: NAVIGATION_HEIGHT,   // sits right under your fixed nav
  left: 0,
  right: 0,
  // height: '1rem',           // exactly the same as WeeksArea’s top padding
  background: '#f0f2f5',    // the surrounding page colour
  zIndex: 3,                //  < WeeksArea (4)  > MainBackground (1)
  pointerEvents: 'none',    // let clicks pass through
})

export const TopOfModuleStrip = styled('div', {
  // This places it in the same grid cell as your modules.
  gridArea: 'switcher',
  position: 'sticky',

  '@media (max-width: 900px)': {
    width: '3.2rem',
  },

  // This tells it to stick to the top of its grid cell and not stretch.
  // alignSelf: 'start',

  // top: '5.6rem',
  borderRight: '1px solid $elementBorder',
  borderTop: '1px solid $elementBorder',
  // Ensure it sits on top of the ModulesArea (which has zIndex: 3).
  zIndex: 10,

  // The height you wanted for your masking area.
  // height: '1.5rem',
  variants: {
    size: {


      lg: {
        top: '9rem',
        height: '1.5rem',

      },
      // 'sm' will apply the halved width
      sm: {
        width: TIMELINE_COL_WIDTH_HALVED,
        // top: '7rem',
        // height: '1rem'
        top: 'var(--timeline-modules-top, 7rem)',
        height: 'var(--timeline-topstrip-h, 50rem)',
      },
    },
  },
  defaultVariants: { size: 'lg' },


  // Match the main page background color to create the masking effect.
  background: '$blueBackground',

  // This creates the curved "cutout" for the underlying ModulesArea
  // corner to align with as it scrolls up.
  borderTopRightRadius: 16,
});


export const BottomOfModuleStrip = styled('div', {
  position: 'fixed',    // Locks to the screen window
  bottom: '1rem',            // Sits at the very bottom
  left: 0,              // Sits on the left edge
  
  // Match the width of the column it is masking
  width: TIMELINE_COL_WIDTH, 

  '@media (max-width: 900px)': {
    width: '3.2rem',
    '&.popup-open': {
      bottom: `calc(1rem + 45dvh / var(--scale, 1))`,
      '&.keyboard-open': {
        display: 'none',
      },
    },
  },
  borderRight: '1px solid $elementBorder',
  borderBottom: '1px solid $elementBorder',
  
  // How tall is the mask area?
  height: '1rem',       
  
  // Match your page background color exactly to create the illusion
  backgroundColor: '$blueBackground', 
  
  // Must be higher than the scrolling ModulesArea (zIndex: 3)
  zIndex: 10000,           
  
  // Let clicks pass through
  pointerEvents: 'none', 

  // ✅ THE FIX: Curve the bottom-right corner.
  // This makes the mask look like the bottom-left corner of a rounded app frame.
  borderBottomRightRadius: '16px', 
});


export const BottomOfMainStrip = styled('div', {
  position: 'fixed',    // Locks to the screen window
  bottom: '2.1rem',    
          // Sits at the very bottom
  left: `calc(${TIMELINE_COL_WIDTH} + 1rem)`,
  
  '@media (max-width: 900px)': {
    left: '4.2rem',
    '&.popup-open': {
      bottom: `calc(2.1rem + 45dvh / var(--scale, 1))`,
      '&.keyboard-open': {
        display: 'none',
      },
    },

  },




  // width: '1rem',

  right: '1rem',
  
  // Match the width of the column it is masking
  // borderRight: '1px solid $elementBorder',
  // borderBottom: '1px solid $elementBorder',
  
  
  // How tall is the mask area?
  height: '1rem',       
  
  // Match your page background color exactly to create the illusion
  backgroundColor: 'white', 
  
  // Must be higher than the scrolling ModulesArea (zIndex: 3)
  zIndex: 600,           
  
  // Let clicks pass through
  pointerEvents: 'none', 

  // ✅ THE FIX: Curve the bottom-right corner.
  // This makes the mask look like the bottom-left corner of a rounded app frame.
  borderBottomRightRadius: '16px', 
  borderBottomLeftRadius: '16px',
});

export const BottomOfMainStripHelper = styled('div', {
  position: 'fixed',    // Locks to the screen window
  bottom: '1.5rem',            // Sits at the very bottom

  left: `calc(${TIMELINE_COL_WIDTH} + 1rem)`,

  '@media (max-width: 900px)': {
    left: '4.2rem',
    '&.popup-open': {
      bottom: `calc(1.5rem + 45dvh / var(--scale, 1))`,
      '&.keyboard-open': {
        display: 'none',
      },
    },

  },

  right: '1rem',
  
  // Match the width of the column it is masking
  // borderRight: '1px solid $elementBorder',
  // borderBottom: '1px solid $elementBorder',
  
  
  // How tall is the mask area?
  height: '1.5rem',       
  
  // Match your page background color exactly to create the illusion
  backgroundColor: '#f0f2f5', 
  
  // Must be higher than the scrolling ModulesArea (zIndex: 3)
  zIndex: 500,           
  
  // Let clicks pass through
  pointerEvents: 'none', 

  // ✅ THE FIX: Curve the bottom-right corner.
  // This makes the mask look like the bottom-left corner of a rounded app frame.
  // borderBottomRightRadius: '16px', 
  // borderBottomLeftRadius: '16px',
});